import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppStore = defineStore(
    'appstore',
    () => {
        const isMenuVisible = ref(false) //是否显示右键菜单
        const isRouterAlive = ref(true) //重新渲染的页面
        const isLoading = ref(false) //标识加载状态

        return {
            isMenuVisible,
            isRouterAlive,
            isLoading,
        }
    },
    {
        persist: true,
    },
)

